import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const DeathCertificate = () => {
  const { language } = useLanguage();
  
  const [formData, setFormData] = useState({
    // Applicant Information
    applicantName: '',
    mobileNumber: '',
    
    // Death Certificate Details
    deceasedName: '',
    gender: '',
    deathDate: '',
    age: '',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission logic here
  };

  const handleReset = () => {
    setFormData({
      applicantName: '',
      mobileNumber: '',
      deceasedName: '',
      gender: '',
      deathDate: '',
      age: '',
      fatherName: '',
      motherName: '',
      village: '',
      taluka: '',
      district: '',
      placeOfDeath: '',
      causeOfDeath: '',
      deathProof: null,
      idProof: null,
    });
  };

  const formSectionStyle = {
    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid #dee2e6',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
  };

  const inputStyle = {
    background: '#ffffff',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    padding: '10px 15px',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    width: '100%',
  };

  const labelStyle = {
    color: '#2c3e50',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px',
    display: 'block',
  };

  const sectionTitleStyle = {
    color: '#2c3e50',
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #3498db',
    textAlign: 'center',
    background: 'linear-gradient(90deg, #3498db 0%, #2c3e50 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  };

  const requiredStar = {
    color: '#e74c3c',
    marginLeft: '3px',
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Form Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
            {language === 'marathi' ? 'मृत्यू दाखला मागणी' : 'Death Certificate Request'}
          </h1>
          <p className="text-gray-600 text-lg">
            {language === 'marathi' ? 'ई-ग्राम पोर्टल - इनाम धामणी ग्रामपंचायत' : 'E-Gram Portal - Inam Dhamani Gram Panchayat'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Section 1: Applicant Information */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'अर्जदार माहिती तपशील' : 'Applicant Information Details'}</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'अर्जदार नाव' : 'Applicant Name'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="applicantName"
                  value={formData.applicantName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'श्री. / सुश्री. / कु. पूर्ण नाव' : 'Mr. / Ms. / Miss. Full Name'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मोबाईल नंबर' : 'Mobile Number'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? '९८७६५४३२१०' : '9876543210'}
                  pattern="[0-9]{10}"
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Section 2: Death Certificate Details */}
          <div style={formSectionStyle}>
            <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'मृत्यू दाखला मागणी तपशील' : 'Death Certificate Request Details'}</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मृत व्यक्तीचे पूर्ण नाव' : 'Deceased Person\'s Full Name'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="deceasedName"
                  value={formData.deceasedName}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'मृत व्यक्तीचे संपूर्ण नाव' : 'Deceased Person\'s Full Name'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मृत व्यक्तीचे लिंग' : 'Deceased Person\'s Gender'} <span style={requiredStar}>*</span>
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">{language === 'marathi' ? 'निवडा' : 'Select'}</option>
                  <option value="male">{language === 'marathi' ? 'पुरुष' : 'Male'}</option>
                  <option value="female">{language === 'marathi' ? 'स्त्री' : 'Female'}</option>
                  <option value="other">{language === 'marathi' ? 'इतर' : 'Other'}</option>
                </select>
              </div>

              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'मृत्यू दिनांक' : 'Death Date'} <span style={requiredStar}>*</span>
                </label>
                <input
                  type="date"
                  name="deathDate"
                  value={formData.deathDate}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label style={labelStyle}>
                  {language === 'marathi' ? 'वय (मृत्यू वेळी)' : 'Age (at time of death)'}
                </label>
                <input
                  type="number"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  style={inputStyle}
                  placeholder={language === 'marathi' ? 'वर्षे' : 'Years'}
                  className="focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Form Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6">
            <button
              type="submit"
              style={{
                background: 'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(46, 204, 113, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
            >
              {language === 'marathi' ? '📄 अर्ज सादर करा' : '📄 Submit Application'}
            </button>

            <button
              type="button"
              onClick={handleReset}
              style={{
                background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '16px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(231, 76, 60, 0.3)',
              }}
              className="hover:shadow-lg transform hover:-translate-y-1"
            >
              {language === 'marathi' ? '🔄 पुनर्स्थापित करा' : '🔄 Reset'}
            </button>
          </div>

          {/* Form Footer */}
          <div className="mt-8 text-center text-sm text-gray-500">
            <p className="mb-2">
              <span style={{color: '#e74c3c', fontWeight: 'bold'}}>*</span> {language === 'marathi' ? 'हे चिन्ह असलेले फील्ड अनिवार्य आहेत' : 'Fields marked with this symbol are mandatory'}
            </p>
            <p>
              {language === 'marathi' 
                ? 'अर्ज सादर केल्यानंतर, तुम्हाला एक अर्ज संदर्भ क्रमांक प्राप्त होईल. कृपया तो संदर्भ क्रमांक नोंदवून ठेवा.'
                : 'After submitting the application, you will receive an application reference number. Please note down that reference number.'}
            </p>
          </div>
        </form>

        {/* Information Box */}
        <div className="mt-10 p-6 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-800 mb-3">{language === 'marathi' ? '📋 महत्वाची सूचना:' : '📋 Important Notice:'}</h3>
          <ul className="list-disc pl-5 space-y-2 text-blue-700">
            <li>{language === 'marathi' ? 'सर्व माहिती अचूक आणि सत्य असल्याची खात्री करा' : 'Ensure all information is accurate and true'}</li>
            <li>{language === 'marathi' ? 'अर्ज सादर केल्यानंतर 3-5 कामकाजाच्या दिवसात दाखला तयार होईल' : 'Certificate will be ready in 3-5 working days after submitting application'}</li>
            <li>{language === 'marathi' ? 'दाखला घेण्यासाठी मूळ कागदपत्रे आणि प्रमाणपत्रे आणणे अनिवार्य आहे' : 'It is mandatory to bring original documents and certificates to collect the certificate'}</li>
            <li>{language === 'marathi' ? 'अर्ज सादर केल्यानंतर स्थिती तपासण्यासाठी संदर्भ क्रमांक वापरा' : 'Use reference number to check status after submitting application'}</li>
            <li>{language === 'marathi' ? 'कोणतीही समस्या असल्यास, ग्रामसेवक कार्यालयात संपर्क साधा' : 'In case of any issues, contact Gram Sevak office'}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DeathCertificate;